export default __webpack_public_path__ + "static/media/logo.e9c6276b.png";